import React, { useEffect, useState } from 'react'
import { FaXmark } from 'react-icons/fa6'
import utils from '../../utils'
import { FiCheckCircle } from 'react-icons/fi'
import { MdInventory2 } from 'react-icons/md'
import adminServices from '../../services/AdminServices'
import { useAuth } from '../../context/UserContext'
import vendorServices from '../../services/VendorSevices'

function ProductStats() {
    const { user } = useAuth()
    const [stats, setStats] = useState()

    useEffect(() => {
        getStoreStats(user)
    }, [user])

    const getStoreStats = (user) => {
        let services;
        if (user?.is_admin) {
            services = adminServices;
        }  
        if (user?.is_vendor) {
            services = vendorServices;
        }
        services.productStats().then(
            res => {
                setStats(res.data)
            },
            err => {
                console.log(err);

            }
        )
    }
    return (
        <div>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Total Products</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.products_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-orange-100 rounded-full">
                            <span className="material-icons text-secondary"><MdInventory2 className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Approved</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.verified_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-red-100 rounded-full">
                            <span className="material-icons text-primary"><FiCheckCircle className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Unapproved</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.unverified_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-orange-100 rounded-full">
                            <span className="material-icons text-secondary"><FaXmark className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductStats